import type { ComponentProps } from 'react';
import { forwardRef, useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';

const subscribeToMount = () => () => undefined;
const getMountedSnapshot = () => true;
const getServerMountedSnapshot = () => false;

type PortalProps = ComponentProps<'div'> & {
	container?: HTMLElement | null;
	'data-test-id'?: string;
};

/**
 * @deprecated not used for overlays in `@launchpad-ui/components`
 */
const Portal = forwardRef<HTMLDivElement, PortalProps>(
	({ container: containerProp, 'data-test-id': testId = 'portal', ...props }, ref) => {
		const mounted = useSyncExternalStore(subscribeToMount, getMountedSnapshot, getServerMountedSnapshot);
		const container = containerProp === undefined ? globalThis?.document?.body : containerProp;

		return mounted && container ? createPortal(<div {...props} ref={ref} data-test-id={testId} />, container) : null;
	},
);

Portal.displayName = 'Portal';

export { Portal };
export type { PortalProps };
